import {
  ArrowForward20Regular,
  ArrowReply20Regular,
  Checkmark20Regular,
  Copy20Regular,
  Delete20Regular,
  Pin20Regular,
} from '@/components/Icon'

export function buildMoreActionsMenuItems({
  onReply,
  onForward,
  onPinForEveryone,
  onDelete,
  text,
  copied,
  showDeleteAction,
}) {
  const items = [
    { id: 'reply', label: 'Reply', Icon: ArrowReply20Regular, disabled: !onReply },
    { id: 'forward', label: 'Forward', Icon: ArrowForward20Regular, disabled: !onForward },
    {
      id: 'copy',
      label: 'Copy message',
      Icon: copied ? Checkmark20Regular : Copy20Regular,
      disabled: !text,
    },
    { id: 'pin', label: 'Pin for everyone', Icon: Pin20Regular, disabled: !onPinForEveryone },
  ]
  if (showDeleteAction) {
    items.push({
      id: 'delete',
      label: 'Delete',
      Icon: Delete20Regular,
      variant: 'danger',
      showDividerBefore: true,
      disabled: !onDelete,
    })
  }
  return items
}
